import { AVA_PICTURE_DISPLAY_NAME } from "./core";
import createTestId from "../../../fabrics/createTestId";

export const createTestIdForAvaPictureElement = createTestId(
    AVA_PICTURE_DISPLAY_NAME,
);
